import * as React from "react";
import * as S from "@styled";
import { connect } from "react-redux";
import { DispatchType, Utilities } from "../../shared/utilities";
import { updateParameter } from "../actions/UpdateParameter";
import { State } from "../model/State";
import LabelWithTooltip from "shared/components/LabelWithTooltip";

export const InputEditor: React.FC<InputEditorWithDispatchProps> = (props) => {
    let label: JSX.Element | string | undefined = Utilities.humanizeLabel(props.label);
    if (props.tooltip) {
        label = <LabelWithTooltip
            label={props.label}
            description={props.tooltip}
            useHover
        />;
    }
    return (
        <S.FormGroup variant={props.hasErrors ? S.FormGroupVariant.error : S.FormGroupVariant.primary}>
            <S.Label>
                {label}
            </S.Label>
            <S.Input
                isFullWidth={true}
                key={props.name}
                type="text"
                disabled={props.disabled}
                onChange={props.onChange}
                value={props.value}
            />
        </S.FormGroup>
    );
};

interface InputEditorProps {
    elementId: string;
    name: string;
    value: string;
    disabled?: boolean;
    label?: string;
    hasErrors?: string;
    tooltip?: string;
}

interface InputEditorWithDispatchProps extends InputEditorProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const mapStateToProps = (state: State, ownProps: InputEditorProps): InputEditorProps => {
    const disabled = state.uiState.disableEdit || state.uiState.isSaving;
    if (state.validation.validationDictionary[ownProps.elementId]) {
        const validationErrors = state.validation.validationDictionary[ownProps.elementId];
        const foundErrorForInput = validationErrors.find((v) => v.parameterKey === ownProps.name);
        if (foundErrorForInput) {
            return Object.assign({}, ownProps, { hasErrors: true, disabled });
        }

    }
    return Object.assign({}, ownProps, { hasErrors: false, disabled });
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: InputEditorProps): InputEditorWithDispatchProps => {
    return Object.assign({}, ownProps, {
        onChange: (event: React.ChangeEvent<HTMLInputElement>) => dispatch(updateParameter(ownProps.elementId, ownProps.name, event.currentTarget.value))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(InputEditor);
